import { useQuery } from "@tanstack/react-query";
import {
  getPapersList,
  Paper,
  PapersListRequestOptions,
  PapersListResponse,
} from "helpers/api";
import {
  BookmarkType,
  IBookmarkItem,
  IPaperBookmark,
  IUploadedPaperBookmark,
} from "helpers/bookmark";

const fetchPaperDetails = async (paperIds: string[]): Promise<Paper[]> => {
  const options: PapersListRequestOptions = {
    include_abstract: false,
    include_badges: true,
    include_journal: false,
  };

  const resDict: PapersListResponse = await getPapersList({
    paper_ids: paperIds,
    options,
  });

  return Object.values(resDict.paperDetailsListByPaperId).map(
    (paperDetails) =>
      ({
        authors: paperDetails.authors,
        badges: paperDetails.badges,
        citation_count: paperDetails.citation_count,
        display_text: paperDetails.abstract_takeaway,
        doc_id: "",
        doi: paperDetails.doi,
        has_valid_chat_pdf: false,
        journal: paperDetails.journal.title,
        pages: paperDetails.pages,
        paper_id: paperDetails.id,
        primary_author: paperDetails.authors[0],
        title: paperDetails.title,
        url_slug: paperDetails.url_slug || "",
        volume: paperDetails.volume,
        year: paperDetails.year,
        publish_date: paperDetails.publish_date,
      }) as Paper
  );
};
const usePaperDetails = (bookmarkListItems: IBookmarkItem[]) => {
  const paperIds = bookmarkListItems
    .filter(
      (x) =>
        x.bookmark_type === BookmarkType.PAPER ||
        x.bookmark_type === BookmarkType.UPLOADED_PAPER
    )
    .map((bookmark) => {
      if (bookmark.bookmark_type === BookmarkType.PAPER) {
        return (bookmark.bookmark_data as IPaperBookmark).paper_id;
      } else {
        return (bookmark.bookmark_data as IUploadedPaperBookmark)
          .uploaded_paper_id;
      }
    });

  return useQuery({
    queryKey: ["paperDetails", paperIds],
    queryFn: () => fetchPaperDetails(paperIds),
    enabled: paperIds.length > 0,
  });
};

export default usePaperDetails;
